/**
 * Ensure that the Shop with Ambassador toolbar displays correctly with main sticky header and announcement bar.
 */

(function () {
  let observer;

  const MOBILE_BREAKPOINT_PIXELS = 750

  function isViewportBelow(maxPx) {
    return window.matchMedia(`(max-width: ${maxPx}px)`).matches;
  }

  function handle() {
    const toolbar = document.querySelector('.gfp_toolbar_style, .gf_toolbar_style');
    if (!toolbar) return;

    const isSticky = toolbar.classList.contains('isSticky');
    const announcementBar = document.querySelector('.announcement-bar');
    const headerWrapper = document.querySelector('.header-wrapper');
    const mainContent = document.querySelector('main');

    if (isSticky) {
      toolbar.style.position = 'fixed';
      mainContent.style.paddingTop = isViewportBelow(MOBILE_BREAKPOINT_PIXELS) ? '125px' : '150px';

      if (announcementBar) { 
        announcementBar.style.position = 'fixed';
        announcementBar.style.width = '100vw';
        announcementBar.style.marginTop = '34px';
        announcementBar.style.top = '3px';
     }

      if (headerWrapper) { 
        headerWrapper.style.position = 'fixed';
        headerWrapper.style.top = 0;
        headerWrapper.style.width = '100vw';
        headerWrapper.style.marginTop = announcementBar ? '72px' : '34px';
      }

    } else {
        toolbar.style.position = 'initial';
        mainContent.style.paddingTop = 'initial';

        if (announcementBar) { 
            announcementBar.style.position = 'initial';
            announcementBar.style.width = 'initial';
            announcementBar.style.marginTop = 'initial';
            announcementBar.style.top = 'initial';
         }
          if (headerWrapper) { 
            headerWrapper.style.position = 'initial';
            headerWrapper.style.width = 'initial';
            headerWrapper.style.marginTop = 'initial';
          }
    }
  }

  function start() {
    handle();
    observer = new MutationObserver(handle);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

